import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,validateNumberLength,TableDatePicker} from '../function_lib/common_lib';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';

import Header from './header';
import Footer from './footer';


import defaultPic from '../assets/images/9.png';

//import Wa_Credit_Balance_Comp from '../components/wa_credit_balance';


let loginUser="";
let userObject="";
let companyName="";
let clsExamMaster;

let rf="0";
class Exam_Master extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={ listUsers:[],stClassMaster:{}};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
          clsExamMaster=this;
      }

      getExamMaster(status="0"){
        //child component use this method loan_document_upload_comp
        var map=[];
        map.push({name:"curl_type",value:"getExamMaster"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"local_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:userObject[0].type});
        //map.push({name:"ser_userType",value:$("#ser_userType").val()});
        map.push({name:"ser_text",value:$("#ser_text").val()});
        //alert(status);
        /*
        if(status!=="0"){
          map.push({name:"status",value:status});
        }
        not required as of now
        */
        map.push({name:"upper_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getExamMaster";
        CallMapMethod_CBack(clsExamMaster,map,function(data,msg){
          //alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
                clsExamMaster.setState({listUsers:listData},()=>{
                  //window.getPagination("#tbData");
                  clsExamMaster.forceUpdateHandler();
                  //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
                 
                  if(rf!=="0"){
                    clsExamMaster.getSearch(rf);
                    //alert("i m in setup "+rf);
                    $("#serLoanStatus").val(rf);
                  }
                });
              }
        });
      }
      okSucc(data,smg){
        if(data==="001"){
          //alert("record added successfully");
          Custom_Alert("Successful","Record Added Successfully",true);
          clsExamMaster.getExamMaster();
          $("#frmCreate").find("input[type=text]").val("");
        }else{
          //alert(smg);
          Custom_Alert("Not Working",smg,false);
        }
        // alert(data);
      }


 onEditClassMaster(classData){
  // method will work on click on Credit Button Link to set State
  clsExamMaster.setState({stClassMaster:classData},()=>{
  })

 }             
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
this.getExamMaster();

$('#divClassMaster').on('hidden.bs.modal', function () {
  //alert("i m in hide");
  clsExamMaster.setState({stClassMaster:{"nn":"00"}});
  clsExamMaster.forceUpdateHandler();
 
});
}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
<div className="row content12 mt-2 mb-2">


<div className='col-lg-4 col-md-4 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <input autoComplete='off' type="text" id="ser_text" name="ser_text" className="_setSearchKeyUp form-control form-control-sm" placeholder='search' />
             </div>
         
         </div>

</div>

<div className="col-lg-2 col-md-2 col-sm-4 vcenter-item1 float-right">
<div className="input-group">
               
               <div className="input-group-prepend">
               <div className='col-12 '>
                 <div onClick={()=>this.getUsers()}  style={{marginRight:"10px"}} className="btn btn-sm btn-danger">Search</div>
                 <div  className="btn btn-sm btn-danger">Reset</div>
                 </div>
               </div>
             </div>

</div>
    </div>    
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card">
              {/* <!-- /.card-header --> */}
           <div class="card-header bg-cyan">
                <h3 class="card-title "><i class="fa fa-arrow-circle-right"></i> <b>Subject Master</b></h3>
                
                <a className="btn btn-sm btn-danger float-right" data-toggle="modal" data-target="#divClassMaster" href="javascript:void(0)">Add New</a>
              </div>
                <table id="tbData" class="dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap1 table-responsive">
                  <thead>
                    <tr class="border">
                      <th>S.No.</th>
                      <th>Exam Name</th>
                      <th>Priority Sequence</th>
                      <th>Academic</th>
                      <th>Status</th>
                      {/* <th>Is Active</th> */}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.listUsers.map((item,index)=>{
                       return(<tr>
                        <td>{index+1}</td>
                        <td>{item.exam_nm}</td>  
                  <td>{item.priority}</td>
                  <td>{item.academic_part}</td>
                  <td>{item.status}</td>
                  {/* <td>{item.is_active}</td> */}
                  <td><a data-toggle="modal" data-target="#divClassMaster" onClick={()=>this.onEditClassMaster(item)}  href="javascript:void(0)">Edit</a> |</td>
                    </tr>)
                  }))}
                  </tbody>
                </table>
                <div class='pagination-container' >
        <nav>
          <ul class="pagination">
            
            <li data-page="prev" >
                     <span> {"<"} <span class="sr-only">(window.current)</span></span>
                    </li>
          
        <li data-page="next" id="prev">
                       <span> {">"} <span class="sr-only">(window.current)</span></span>
                    </li>
          </ul>
        </nav>
      </div>
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Alert_Content/>
<Footer/>
<div className="modal fade bd-example-modal-xl"  id="divClassMaster" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog" role="document">
    <div className="modal-content">
    <div className="modal-header bg-primary">
        <h5 className="modal-title text-white" id="exampleModalLabel">{typeof this.state.stClassMaster.id==="undefined"?"Add New Exam":"Edit Exam"}</h5>
        <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" className="text-white">&times;</span>
        </button>
      </div>
      <form id="frmExamMaster" name="frmExamMaster">
     
      <div className="modal-body">
      <div className="row">
                {/* <!-- left column --> */}
                <div className="col-md-12">
                    <div className="card card-danger">
                            <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                            <input type="hidden" name="curl_type" id="curl_type" value="createExamMaster" />
                            <input type="hidden" name="m_type" id="m_type" value="createExamMaster" />
                            <input type="hidden" name="type_id" id="type_id" value="2" />
                            <input type="hidden" name="upper_id" id="upper_id" value={userObject[0].app_user_id} />
                            <input type="hidden" name="exam_master_id" id="exam_master_id" value={typeof this.state.stClassMaster.id!=="undefined"?btoa(this.state.stClassMaster.id):"0"}/>
                            <div className="card-body">
                                <div className="row">
                                
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Exam Name *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="exam_nm" name="exam_nm" defaultValue={this.state.stClassMaster.exam_nm} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Exam Code *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="exam_code" name="exam_code" defaultValue={this.state.stClassMaster.exam_code} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Outstanding Marks *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="number" id="outs_marks" name="outs_marks" defaultValue={this.state.stClassMaster.outs_marks} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Priority *</label>
                                            <div className="input-group input-group-sm">
                                                <input type="number" id="priority" name="priority" defaultValue={this.state.stClassMaster.priority} className="form-control required" placeholder="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Academic Part *</label>
                                            <div className="input-group input-group-sm">
                                                <select id="academic_part" name="academic_part" class="form-control required">
                                                    <option value="0">Select</option>
                                                    <option value="Academic">Academic</option>
                                                    <option value="Co-Scholastic">Co-Scholastic</option>

                                                </select>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Is Active *</label>
                                            <div className="input-group input-group-sm">
                                              <select id="is_active" name="is_active" className="form-control required">
                                                <option value={"0"}>-Select-</option>
                                                <option selected={this.state.stClassMaster.is_active==="Active"} value={"Active"}>Active</option>
                                                <option selected={this.state.stClassMaster.is_active==="Deactive"} value={"Deactive"}>Deactive</option>
                                              </select>
                                                
                                            </div>
                                        </div>
                                    </div>

                                </div>
                              
                                <div className="col-md-6 respSSL"></div>
                                <div id="testing2dd2222"></div>
                            </div>
                        
                    </div>
                </div>
            </div>
      </div>
      <div className="modal-footer">
      <div id="getReponse" style={{color:"red"}}></div>
        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" className="btn _btnSetColor btn-primary">{typeof this.state.stClassMaster.id==="undefined"?"Add New":"Update Now"}</button>
      </div>
      </form>
    </div>
    </div>
    </div>
    {/* <Wa_Credit_Balance_Comp creditUser={this.state.crediUser} creditBalance={this.state.creditBalance} masterBalance={this.state.masterBalance} app_user_id={userObject[0].app_user_id} /> */}
          </div>)
      }
}
export default Exam_Master;